import React from 'react'
import Header from '../common/header'
import styled from 'styled-components'
import Footer from '../common/footer'
import { html as eula } from './eula.md'
import Spacer from '../lib/spacer'
import womanStretch from '../img/woman-stretch.webp'
import { useTranslation } from '../lib/i18n'
import LegalNotice from '../common/legal_notice'

const Wrapper = styled.div`
    div h2 {
        font-size: 1.25rem;
    }
`

const WomanStretchImage = styled.img`
    width: 280px;
    display: block;
    margin: 0 auto;
`

export default () => {
    const { t } = useTranslation(undefined, { keyPrefix: 'eula' })

    return (
    <>
        <Header />
        <Spacer className="show-for-large" size={60} />
        <Spacer className="hide-for-large" size={30} />
        <div className="grid-container">
            <div className="grid-x align-center">
                <Wrapper className="cell">
                    <h1 className="h2 header">{t('heading')}</h1>
                    <Spacer size={20} />
                    <LegalNotice />
                    <div dangerouslySetInnerHTML={{ __html: eula }}></div>
                    <Spacer size={40} />
                    <WomanStretchImage src={womanStretch} alt={t('imageAlt')} />
                </Wrapper>
            </div>
            <Footer />
        </div>
    </>
)
}
